import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, model, output } from '@angular/core';
import { CheckboxComponent } from '@shared/components/checkbox';
import { ImageComponent } from '@shared/components/image';
import { Image } from '@shared/components/image/models';
import { SvgComponent } from '@shared/components/svg';
import { CostLevel } from '@shared/enums';
import { GenerateRangePipe } from '@shared/pipe';

@Component({
  selector: 'app-option-card-select',
  imports: [ImageComponent, SvgComponent, CheckboxComponent, NgClass, GenerateRangePipe],
  templateUrl: './option-card-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OptionCardSelectComponent {
  readonly image = input<Image>();
  readonly name = input.required<string>();
  readonly costLevel = input<CostLevel>();
  readonly description = input<string>();
  readonly isInEditMode = input(false);
  readonly showCheckbox = input(false);
  readonly selected = model(false);
  readonly isPriority = input(false);
  readonly onEditAction = output<void>();

  handleEditButtonClick(): void {
    if (this.isInEditMode()) this.onEditAction.emit();
  }
}
